<template>
  <footer class="footer" style="margin-top: -1px">
    <section class="footer-container adaption">
<!--      <div class="left-box">-->
<!--        <div class="left">-->
<!--          <div><img class="header-logo" v-lazy="require('../assets/footer/logo.png')" alt=""/></div>-->
<!--          <div>-->
<!--            <div style="display:flex">-->
<!--              <div v-for="item in routeList.slice(0,6)" :key="item.key" class="menu-item" @click="push(item.value)">-->
<!--                {{ item.key }}-->
<!--              </div>-->
<!--            </div>-->
<!--            <div style="display:flex">-->
<!--              <div v-for="item in routeList.slice(6,8)" :key="item.key" class="menu-item" @click="push(item.value)">-->
<!--                {{ item.key }}-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

<!--        </div>-->

<!--        <div class="copy-right">Copyright @2019-2023、Beijing DualPi Intelligent Security Technology Co., LTD. All rights reserved-->
<!--        </div>-->
<!--        <div class="address">公司地址：北京市西城区新街口外大街普天德胜科技园 C座604</div>-->
<!--        <div class="icp" @click="jumpIcp">ICP备案号：【京ICP备20009331号-1】</div>-->
<!--      </div>-->


<!--      <div class="email-box">-->
<!--        <div>-->
<!--          <img src="@/assets/assetsNewImg/index/email.png">-->
<!--        </div>-->
<!--        <div class="email-text">服务邮箱：</div>-->
<!--        <div class="email-text">service@dualpi.com</div>-->
<!--        <div class="email-text">周一至周日 0:00-24:00</div>-->
<!--      </div>-->

<!--      <div class="email-box">-->
<!--        <div>-->
<!--          <img style="width: 34px;height: 32px;" src="@/assets/footer/contact.png">-->
<!--        </div>-->
<!--        <div class="email-text">联系方式：</div>-->
<!--        <div class="email-text">战略合作 13810235805（黄女士）</div>-->
<!--        <div class="email-text">产品咨询 13606508343（王先生）</div>-->
<!--        <div class="email-text">产品咨询 15142070576（徐先生）</div>-->
<!--      </div>-->

<!--      <div class="wei-xin-box">-->
<!--        <div>-->
<!--          <img src="../assets/footer/qr.png" alt="">-->
<!--        </div>-->
<!--        <div class="wei-xin-text">官方微信</div>-->
<!--      </div>-->

<!--      <div class="wei-xin-box">-->
<!--        <div>-->
<!--          <img src="../assets/footer/qr.png" alt="">-->
<!--        </div>-->
<!--        <div class="wei-xin-text">官方公众号</div>-->
<!--      </div>-->

      <!--            <div class="top-button" @click="toTop">-->
      <!--                <div class="top-icon"></div>-->
      <!--                <div class="top-text">TOP</div>-->
      <!--            </div>-->
      <div style="display: flex">
        <div class="logo-box"></div>
        <div class="first-level-title first-gap click-icon" @click="changeRoute('home')">双湃智安</div>
        <div class="second-gap">
          <div class="first-level-title">安全产品</div>
          <div class="second-level-title click-icon" @click="redirectToPro(0)">安全产品全景视图</div>
          <div class="second-level-title click-icon" @click="redirectToPro(1)">全领域安全产品</div>
          <div class="second-level-title click-icon" @click="redirectToPro(2)">教育与研究</div>
        </div>
        <div class="first-gap">
          <div class="first-level-title">行业解决方案与案例</div>
          <div v-for="(item,index) in solutionList" :key="index" class="second-level-title click-icon" @click="redirectToSolution(item.id)">{{item.name}}</div>
        </div>
        <div class="first-gap">
          <div class="first-level-title">安全服务</div>
          <div v-for="(item,index) in serviceList" :key="index" class="second-level-title click-icon" @click="redirectToService(item.id)">{{item.name}}</div>
        </div>
        <div class="first-level-title fifth-gap click-icon" @click="changeRoute('lab')">实验室</div>
        <div class="first-level-title fifth-gap click-icon" @click="changeRoute('space')">可信数据空间</div>
        <div class="first-level-title fifth-gap click-icon" @click="changeRoute('doctor')">博士后工作站</div>
        <div class="first-level-title fifth-gap click-icon" @click="changeRoute('situation')">安全态势</div>
        <div class="first-level-title fifth-gap click-icon" @click="changeRoute('maas')">MaaS平台</div>
        <div class="first-level-title click-icon" @click="changeRoute('about')">关于我们</div>
        <div class="wechat-box">
          <div class="concat-box wechat-bottom-gap">
<!--            <div class="wechat-center-gap">-->
<!--              <div class="wechat-pic"></div>-->
<!--              <div class="wechat-text">官方微信</div>-->
<!--            </div>-->
            <div>
              <div class="wechat-pic"></div>
              <div class="wechat-text">官方公众号</div>
            </div>
          </div>
          <div class="concat-box">
            <div>服务时间：</div>
            <div class="time-gap">周一至周日 0:00-24:00</div>
          </div>
          <div>联系方式：</div>
          <div class="concat-box">
            <div>战略合作</div>
            <div class="concat-gap">13810235805(黄女士)</div>
          </div>
          <div class="concat-box">
            <div>产品咨询</div>
            <div class="concat-gap">
              <div>13606508343(王先生)</div>
              <div>15142070576(徐先生)</div>
            </div>
          </div>
          <div>服务邮箱：</div>
          <div>service@dualpi.com</div>
          <div class="address-top-gap">公司地址：</div>
          <div class="address-text">北京市西城区新街口外大街普天德胜科技园 C 座604</div>
          <div class="address-text">辽宁省沈阳市浑南区上深沟村860-1号B507房间（沈阳国际软件园F8座）</div>
        </div>
      </div>
      <div class="copyright-text copyright-gap">Copyright @2019-{{thisYear}}、Beijing DualPi Intelligent Security Technology Co.Ltd.All rights reserved</div>
      <div class="copyright-text click-icon" @click="jumpIcp">ICP备案号：【京ICP备20009331号-1】</div>
    </section>
  </footer>
</template>

<script>
import {mapState} from "vuex";
import {top} from "../utils/common";

export default {
  name: "footer",
  inject:["reload"],
  computed: {
    ...mapState("menu", ["activeRoute", "routeMap","solutionList","serviceList"]),
    routeList() {
      const list = Object.keys(this.routeMap);

      return list.map(item => {
        return {
          key: item,
          value: this.routeMap[item]
        };
      });
    },
    thisYear() {
      return new Date().getFullYear();
    }
  },
  methods: {
    push(value) {
      if (value !== this.activeRoute) {
        this.$router.push("/" + value);
        this.toTop();
      }
    },
    changeRoute(val) {
      this.$router.push("/" + val);
      this.toTop();
    },
    redirectToPro(index) {
      this.$router.push({path: "/product",query: {index}});
      this.reload();
    },
    redirectToSolution(index) {
      this.$router.push({path: "/solution/solutionView", query:{name: index, key : "1"}});
      this.reload();
    },
    redirectToService(index) {
      const name = String(index - 1);

      this.$router.push({path: "/service/serviceView", query:{name, key : "0"}});
      this.reload();
    },
    jumpIcp() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index", "_blank");
    },
    toTop() {
      top();
    }
  }
};
</script>

<style scoped lang="less">
@font-face {
  font-family: 'OPPOSans';
  src: url('../assets/assetsNewImg/lab/OPPOSans H.ttf');
}

.footer {
  position: relative;
  width: 100%;
  height: 639px;
  background: #2D333E;

  .footer-container {
    height: 100%;
    box-sizing: border-box;
    padding-left: 166px;
    padding-top: 95px;
    .logo-box {
      width: 94px;
      height: 40px;
      background-size: 100%;
      background-image: url('../assets/footer/logo.png');
      margin-right: 64px;
    }
    .first-level-title {
      color: #FFFFFFB2;
      font-size: 14px;
      height: 18px;
      line-height: 18px;
      font-family: 'OPPOSans';
      margin-bottom: 26px;
    }
    .second-level-title {
      color: #FFFFFF;
      font-size: 14px;
      height: 18px;
      line-height: 18px;
      //font-family: 'OPPOSans';
      margin-bottom: 22px;
    }
    .first-gap {
      margin-right: 56px;
    }
    .second-gap {
      margin-right: 71px;
    }
    .third-gap {
      margin-right: 27px;
    }
    .forth-gap {
      margin-right: 54px;
    }
    .fifth-gap {
      margin-right: 44px;
    }
    .wechat-box {
      margin-left: 59px;
      font-size: 14px;
      color:#FFFFFF;
      line-height: 24px;
      font-family: 'OPPOSans';
      .address-text {
        width: 238px;
        text-align: justify;
      }
      .address-top-gap {
        margin-top: 24px;
      }
      .concat-box {
        display: flex;
        .concat-gap {
          margin-left: 12px;
        }
        .time-gap {
          margin-left: 8px;
        }
      }
      .wechat-center-gap {
        margin-right: 26px;
      }
      .wechat-text {
        font-size: 16px;
        line-height: 35px;
        text-align: center;
      }
      .wechat-pic {
        width: 101px;
        height: 101px;
        background-size: 100%;
        background-image: url('../assets/footer/qr.png');
      }
      .wechat-bottom-gap {
        margin-bottom: 10px;
      }
    }
    .copyright-text {
      font-size: 14px;
      line-height: 28px;
      color:#97A0B7;
      font-family: 'OPPOSans';
    }
    .copyright-gap {
      margin-top: 10px;
    }
    .click-icon {
      cursor: pointer;
    }
    //.left-box {
    //  margin-left: 100px;
    //  margin-top: 80px;
    //
    //  .left {
    //    display: flex;
    //    height: 40px;
    //    line-height: 40px;
    //
    //    .menu-item {
    //      cursor: pointer;
    //      color: #FFF;
    //      font-family: OPPOSans;
    //      font-size: 16px;
    //      font-weight: 400;
    //      margin: 0 23px;
    //    }
    //  }
    //
    //  .copy-right {
    //    margin-top: 59px;
    //    color: #97A0B7;
    //    font-family: OPPOSans;
    //    font-size: 14px;
    //    font-weight: 400;
    //    line-height: 200%;
    //  }
    //
    //  .address {
    //    color: #97A0B7;
    //    font-family: OPPOSans;
    //    font-size: 14px;
    //    font-weight: 400;
    //    line-height: 200%;
    //    display: table;
    //  }
    //
    //  .icp {
    //    cursor: pointer;
    //    color: #97A0B7;
    //    font-family: OPPOSans;
    //    font-size: 14px;
    //    font-weight: 400;
    //    line-height: 200%;
    //    display: table;
    //  }
    //
    //  .icp:hover {
    //    color: white;
    //  }
    //}
    //
    //.email-box {
    //  margin-left: 35px;
    //  margin-top: 80px;
    //
    //  :first-child {
    //    margin-bottom: 10px;
    //  }
    //
    //  .email-text {
    //    color: #FFF;
    //    font-family: OPPOSans;
    //    font-size: 16px;
    //    font-style: normal;
    //    font-weight: 400;
    //    line-height: normal;
    //  }
    //}
    //
    //.wei-xin-box {
    //  margin-left: 20px;
    //  margin-top: 80px;
    //
    //  .wei-xin-text {
    //    color: #FFF;
    //    font-family: OPPOSans;
    //    font-size: 16px;
    //    font-weight: 400;
    //    text-align: center;
    //  }
    //}
  }

  .top-button {
    position: absolute;
    top: 35px;
    right: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;

    .top-icon {
      width: 5px;
      height: 59px;
      background: url("../assets/footer/top.svg") no-repeat;
    }

    .top-text {
      padding-left: 5px;
      font-size: 14px;
    }
  }
}
</style>
